import classNames from 'classnames';
import type { FocusEvent } from 'react';
import styles from './SliderNumberInput.module.scss';

type SliderNumberInputProps = {
  id: string;
  value: string | null;
  unit?: string;
  min: number | null;
  max: number | null;
  unitWidth?: number;
  onChange: (value: string) => void;
  onBlur: (value: string) => void;
  onFocus?: (value: FocusEvent) => void;
  placeholder?: string;
};

/**
 *
 * @deprecated please use FilterRangeInput from @hub/category/Filters/components/ui instead
 * @returns
 */
export const SliderNumberInput = ({
  id,
  value,
  unit,
  min,
  max,
  unitWidth,
  onChange,
  onBlur,
  onFocus,
  placeholder,
}: SliderNumberInputProps) => (
  <>
    <span
      className={classNames(
        'right-4',
        'absolute',
        unitWidth ? `w-${unitWidth}` : 'w-12',
        'mt-2',
        styles.unitText,
        'text-right'
      )}
    >
      {unit}
    </span>
    <span className={classNames('block', 'overflow-hidden')}>
      <input
        placeholder={placeholder}
        data-testid={id}
        onChange={event => onChange(event.target.value)}
        onBlur={event => onBlur(event.target.value)}
        onFocus={event => onFocus?.(event)}
        className={classNames(
          'w-full',
          'mb-2',
          'mr-4',
          'px-6',
          'py-2',
          'appearance-none',
          'focus:outline-none',
          'border',
          'border-gray-200',
          'rounded',
          styles.input
        )}
        type="number"
        value={value !== null ? value : ''}
        min={min || undefined}
        max={max || undefined}
      />
    </span>
  </>
);
